import BestellungFiliale from "@/entities/common/bestellung_filiale"
import { Verzehrart } from "@/entities/common/enums"
import BPAbholungVerzehrartRequest from "@/entities/common/pending/bp_abholung_verzehrart_request"
import RemoteResult from "@/entities/common/remote_result"
import router from "@/router"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class VerzehrartLogic extends BaseLogic {
  insertError: boolean = false
  insertWorking: boolean = false

  verzehrart?: string = Verzehrart.MITNAHME

  get filiale(): BestellungFiliale {
    return this.mainLogic.filiale
  }

  verzehrarten = [
    { label: "Zum Mitnehmen", value: Verzehrart.MITNAHME },
    { label: "Verzehr im Restaurant", value: Verzehrart.VOR_ORT },
  ]

  weiter() {
    this.insertError = false
    this.insertWorking = true

    var request = new BPAbholungVerzehrartRequest()
    request.id = vuexStore.state.user.identifier
    request.verzehrart = this.verzehrart

    Poster.postMember<RemoteResult<any>>(
      RestPaths.bestellungpendingAbholungVerzehrart,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.mainLogic.bestellungPending.abholung.verzehrart = this.verzehrart

          router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }
}
